import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';

import { CommonModule } from '@angular/common';
import { UneteAhora } from './afiliaciones-components/unete-ahora';
import { BeneficiosDelPrograma } from './afiliaciones-components/beneficios';
import { GaugeComienzaAGanar } from './afiliaciones-components/gauge-comienza-a-ganar';
import { GuiaAfiliarse } from './afiliaciones-components/guia-afiliarse';
import { CanjeaPuntos } from './afiliaciones-components/canjea-puntos';
import { PreguntasFrecuentesAfiliaciones } from './afiliaciones-components/preguntas-frecuentes';
import { NoEsperesMas } from './afiliaciones-components/no-esperes-mas';
import { MoreServices } from './more-services';

@Component({
  selector: 'allas-afiliaciones',
  imports: [
    CommonModule,
    MainLayout,
    UneteAhora,
    BeneficiosDelPrograma,
    GaugeComienzaAGanar,
    GuiaAfiliarse,
    CanjeaPuntos,
    PreguntasFrecuentesAfiliaciones,
    NoEsperesMas,
    MoreServices,
  ],
  template: `
    <allas-main-layout>
      <div class="bg-white w-full max-w-[1600px] mx-auto px-4 2xl:px-0">
        <!-- Titulo Programa de Recompensas -->
        <h1 class="text-lg xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
          PROGRAMA DE RECOMPENSAS
        </h1>

        <!-- Banner de Unete Ahora -->
        <allas-unete-ahora />

        <!-- Titulo Beneficios del Programa -->
        <h2
          class="text-xl xl:text-4xl mb-2 xl:mb-6 mt-4 xl:mt-8 w-full text-center xl:text-left fs-condensed"
        >
          BENEFICIOS DEL PROGRAMA
        </h2>

        <!-- Beneficios del Programa -->
        <allas-beneficios-del-programa />

        <!-- Comienza a Ganar -->
        <allas-gauge-comienza-a-ganar />

        <!-- Como Afiliarse -->
        <allas-guia-afiliarse />

        <!-- Acumular Recompensas -->
        <article
          class="flex flex-col justify-center items-center p-4 xl:p-8 w-full max-w-7xl mx-auto"
        >
          <h2
            class="text-2xl xl:text-5xl font-bold fs-condensed mt-2 ml-1 xl:ml-12 xl:mt-8 text-center xl:text-left"
          >
            ACUMULAR RECOMPENSAS ES FÁCIL Y SIMPLE
          </h2>
          <span
            class="text-center xl:text-left text-base xl:text-lg font-light"
          >
            Cada vez que hagas una compra ganarás puntos, y estos se agregarán
            automaticamente a tu cuenta.
          </span>
        </article>

        <!-- Canjea tus puntos -->
        <allas-canjea-puntos />

        <!-- PREGUNTAS FRECUENTES -->
        <allas-preguntas-frecuentes-afiliaciones />

        <!-- No esperes más -->
        <allas-no-esperes-mas />

        <!-- Más servicios -->
        <allas-more-services />
      </div>
    </allas-main-layout>
  `,
})
export class Afiliaciones implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Programa de Recompensas | Allas Repuestos';
    const description =
      'Únete gratis al programa de recompensas Allas Repuestos. Gana puntos por cada compra y canjéalos por premios. Descuentos especiales y envío a domicilio en Honduras.';
    const keywords =
      'programa recompensas, puntos Allas Repuestos, afiliación gratis, descuentos repuestos, envío a domicilio, Honduras, app móvil, canjear puntos';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
